import { registerVueComponentAndAngularBindings} from '/vodalys/vvuejs'

import Studio20Layout23 from './Studio20Layout23.vue'
registerVueComponentAndAngularBindings('studio20_layout23:component', 'studio20Layout23', Studio20Layout23)